import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

  urlRoot : '/networks'

});